export const MobileDocumentIdentifierSystem = {
  BinaryId: "vibrant.document.binary-id",
  FileFingerprint: "vibrant.document.file-fingerprint",
  SessionFileId: "vibrant.document.session-file-id",
  SessionId: "vibrant.document.session-id",
  LocalFileId: "vibrant.document.local-file-id",
  Origin: "vibrant.document.origin",
} as const;

export const MobileDocumentOriginValue = {
  Records: "mobile-records",
  Share: "mobile-share",
} as const;

export type MobileDocumentOrigin =
  (typeof MobileDocumentOriginValue)[keyof typeof MobileDocumentOriginValue];

export function buildMobileDocumentSessionFileId({
  sessionId,
  localFileId,
}: {
  sessionId: string;
  localFileId: string;
}): string {
  return `${sessionId}:${localFileId}`;
}
